module.exports = __webpack_public_path__ + "static/img/3-6.b1fa4a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-6.jpg
// module id = 741
// module chunks = 1